module.exports = __webpack_public_path__ + "media/images/location-6b41565d008105823ac0d2bcd61d0d78.svg";